import React from "react";
import { Stack } from "@mui/material";
import MasterSearchField from "./MasterSearchField";
import MasterSelect, { MasterSelectOption } from "./MasterSelect";
import MasterToolbarButton from "./MasterToolbarButton";

type MasterListToolbarProps = {
  selectValue?: string;
  selectPlaceholder?: string;
  selectOptions?: MasterSelectOption[];
  onSelectChange?: (value: string) => void;
  select2Value?: string;
  select2Placeholder?: string;
  select2Options?: MasterSelectOption[];
  onSelect2Change?: (value: string) => void;
  actions?: React.ReactNode;
  searchValue?: string;
  searchPlaceholder?: string;
  onSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
};

export default function MasterListToolbar({
  selectValue = "",
  selectPlaceholder,
  selectOptions,
  onSelectChange,
  select2Value = "",
  select2Placeholder,
  select2Options,
  onSelect2Change,
  actions,
  searchValue,
  searchPlaceholder = "Search...",
  onSearch,
  onClear,
}: MasterListToolbarProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      alignItems="center"
      justifyContent="flex-end"
      flexWrap="nowrap"
    >
      {selectOptions && onSelectChange ? (
        <MasterSelect
          toolbar
          value={selectValue}
          placeholder={selectPlaceholder}
          options={selectOptions}
          onChange={(event) => onSelectChange(event.target.value)}
        />
      ) : null}
      {onSelect2Change ? (
        <MasterSelect
          toolbar
          value={select2Value}
          placeholder={select2Placeholder}
          options={select2Options || []}
          onChange={(event) => onSelect2Change(event.target.value)}
        />
      ) : null}
      {actions}
      {onSearch ? (
        <MasterSearchField
          inline
          value={searchValue}
          onChange={onSearch}
          placeholder={searchPlaceholder}
        />
      ) : null}
      {onClear ? (
        <MasterToolbarButton onClick={onClear}>Clear filter</MasterToolbarButton>
      ) : null}
    </Stack>
  );
}
